import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { ErrorHandlerOptions, SentryErrorHandler } from '@sentry/angular';

/**
 * Implementation of Sentry's ErrorHandler provider.
 */
@Injectable({ providedIn: 'root' })
export class PaystashioErrorHandler extends SentryErrorHandler {
  public constructor() {
    const options: ErrorHandlerOptions = {
      showDialog: true,
    };
    super(options);
  }

  override handleError(error: unknown): void {
    // Do not log HttpErrors
    if (error instanceof HttpErrorResponse) {
      return;
    }
    super.handleError(error);
  }
}

/**
 * Custom error handler ignoring HTTP errors.
 */
@Injectable({ providedIn: 'root' })
export class SimpleErrorHandler extends ErrorHandler {
  constructor() {
    super();
  }

  override handleError(error: unknown): void {
    // Do not log HttpErrors
    if (error instanceof HttpErrorResponse) {
      console.warn('HTTP error occurred (not logged):', error.status, error.statusText);
      return;
    }
    // Log non-HTTP errors to console before passing to Angular's default handler
    console.error('Application error:', error);
    super.handleError(error);
  }
}
